import { useContext, useEffect } from "react";
import { FaUserFriends, FaBaby, FaHome, FaHeart, FaStar } from "react-icons/fa";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import CheckBox from "components/ui/controls/check-box/check-box";
import "./Enfants.css";

const Enfants = () => {
  const context = useContext(AppContext);
  const chargeEnfant = [
    {
      value: "exclusive",
      label: "A charge exclusive",
    },
    {
      value: "partagee",
      label: "A charge partagée",
    },
    {
      value: "none",
      label: "Plus à charge",
    },
  ];
  const rattachement = [
    {
      value: "commune",
      label: "Couple",
    },
    {
      value: "client",
      label: "Client",
    },
    {
      value: "conjoint",
      label: "Conjoint",
    },
  ];

  // Fonction pour obtenir l'ordinal en français
  const getOrdinalFrench = (index) => {
    const ordinals = [
      "Premier", "Second", "Troisième", "Quatrième", "Cinquième",
      "Sixième", "Septième", "Huitième", "Neuvième", "Dixième"
    ];
    return ordinals[index] || `${index + 1}ème`;
  };

  // Fonction pour capitaliser seulement la première lettre
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Synchroniser le nombre d'enfants avec la longueur du tableau
  useEffect(() => {
    if (context.state.Enfant !== context.state.TableauEnfant.length) {
      // Créer un event factice pour déclencher la synchronisation
      const syntheticEvent = {
        target: {
          value: context.state.TableauEnfant.length
        }
      };
      context.handleCreationTableauEnfant(syntheticEvent);
    }
  }, [context.state.TableauEnfant.length]);

  return (
    <div className="enfants-container">
      <Column fill>
        <CardBox>
          <Column fill>
            <Row className="enfants-header">
              <div className="enfants-count-field">
                <TextField
                  label="Nombre d'enfants"
                  value={context.state.Enfant}
                  onChange={context.handleCreationTableauEnfant}
                  dataType="uint"
                  normal
                />
              </div>
            </Row>
            <Row tpad>
              {context.state.TableauEnfant.length > 0 && (
                <div className="enfants-single-card">
                  <div className="enfants-card-header">
                    <div className="enfants-card-icon">
                      <FaUserFriends />
                    </div>
                    <h3 className="enfants-card-title">
                      {capitalizeFirst("Tableau des enfants")}
                    </h3>
                  </div>
                  <div className="enfants-table-content">
                    {context.state.TableauEnfant.map((data, index) => (
                      <div key={index} className="enfants-row">
                        <div className="enfants-row-header">
                          <span className="enfants-row-number">{capitalizeFirst(getOrdinalFrench(index) + " enfant")}</span>
                        </div>
                        <div className="enfants-row-content">
                          <div className="enfants-card-field">
                            <label className="enfants-card-field-label">Prénom</label>
                            <TextField 
                              value={data.Prenom} 
                              onChange={(e) => context.handleModificationEnfant(index, "Prenom", e)} 
                              normal 
                              placeholder="Saisir le prénom"
                            />
                          </div>
                          <div className="enfants-card-field">
                            <label className="enfants-card-field-label">Date de naissance</label>
                            <TextField 
                              value={data.DateNaissance} 
                              onChange={(e) => context.handleModificationEnfant(index, "DateNaissance", e)} 
                              dataType="date" 
                              normal 
                            />
                          </div>
                          <div className="enfants-card-field">
                            <label className="enfants-card-field-label">Situation fiscale</label>
                            <DropDown
                              value={data.Charge}
                              options={chargeEnfant}
                              onChange={(e) => context.handleModificationEnfant(index, "Charge", e)}
                              normal
                            />
                          </div>
                          <div className="enfants-card-field">
                            <label className="enfants-card-field-label">Rattachement</label>
                            <DropDown
                              value={data.Rattachement}
                              options={rattachement}
                              onChange={(e) => context.handleModificationEnfant(index, "Rattachement", e)}
                              normal
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Row>
          </Column>
        </CardBox>
      </Column>
    </div>
  );
};

export default Enfants;
